import { useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import { TshirtTeam } from '@/components/TshirtTeam';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useTshirtAndShield from '@/hooks/useTshirtAndShield';
import ROUTES from '@/router/routes';

interface Props {
  tactic?: {
    id: number;
    formation: number[];
  };
  infoDt: {
    name: string;
    nameTeam: string;
  };
}

export const BoxTshirtEdit = (props: Props) => {
  const { tactic, infoDt } = props;
  const { isDesktop } = useIsDesktop();

  const { data: dataTshirtShield } = useTshirtAndShield();

  const navigaate = useNavigate();

  const tShirtLabel = 'Modificar camiseta';

  if (isDesktop) {
    return (
      <>
        <div className="bg-white rounded-lg py-12 px-6 flex">
          <figure className="w-[4.5rem]">
            <TshirtTeam
              id={infoDt.name}
              shield={dataTshirtShield?.shield}
              tshirt={dataTshirtShield?.tshirt}
              withShield={true}
            />
          </figure>
          <div className="ml-7">
            <p className="text-lg font-bold text-gdt-gray">{infoDt.nameTeam}</p>
            <span className="text-gdt-gray-3 block mt-2">DT {infoDt.name}</span>
            <Button
              className="font-bold underline-offset-[6px] mt-4 invisible"
              href="#"
              type="link"
              variant="text"
              onClick={() => navigaate(ROUTES.editAccount.myTeam)}
            >
              {tShirtLabel}
            </Button>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="bg-white rounded-lg p-4 flex justify-between items-center mt-4">
      <Button
        className="pointer-events-none w-[5.625rem] font-extrabold"
        type="button"
        variant="secondary"
      >
        {tactic && String(tactic.formation).replaceAll(',', '-')}
      </Button>
      <Button
        className="font-extrabold underline-offset-[6px] lg:w-[12.5rem] flex items-center justify-between space-x-[0.44rem]"
        type="button"
        variant="secondary"
        onClick={() => alert('Implementar')}
      >
        <figure>
          <svg
            fill="none"
            height="19"
            viewBox="0 0 19 19"
            width="19"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5087 2.36523C11.5087 2.36523 10.7273 2.63965 9.5 2.63965C8.27268 2.63965 7.49129 2.36523 7.49129 2.36523C7.36782 2.36524 7.24523 2.38611 7.12872 2.42698L1.81641 4.28613L2.38684 7.30469L4.06351 7.49403C4.26884 7.51727 4.45793 7.61688 4.59321 7.77307C4.7285 7.92927 4.8001 8.13063 4.7938 8.33717L4.56055 16.6348H14.4395L14.2062 8.33717C14.1999 8.13063 14.2715 7.92927 14.4068 7.77307C14.5421 7.61688 14.7312 7.51727 14.9365 7.49403L16.6132 7.30469L17.1836 4.28613L11.8713 2.42698C11.7548 2.38611 11.6322 2.36524 11.5087 2.36523V2.36523Z"
              stroke="#3366FF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.09766"
            />
            <path
              d="M12.1519 2.52539C11.9963 3.10995 11.652 3.62673 11.1724 3.99539C10.6929 4.36405 10.1049 4.56391 9.50001 4.56391C8.89512 4.56391 8.30717 4.36405 7.82759 3.99539C7.34802 3.62673 7.00369 3.10995 6.84814 2.52539"
              stroke="#3366FF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.09766"
            />
          </svg>
        </figure>
        <span>{tShirtLabel}</span>
      </Button>
    </div>
  );
};
